import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { Point2D } from "../../../../common/Point2D";
import {
	moveSheetTo,
	selectTab,
	updateConnection,
	updateMemoryRef,
	updateOperator,
} from "../../editorSlice";
import { uniqBy } from "lodash";

export interface IoErrors {
	id: string;
	box: Point2D;
	type: "memoryRef" | "operator" | "connection";
	message: string;
	sheet: number;
}

interface ToastProps {
	title: string;
	errors: Array<IoErrors>;
}

export function Toast({ title, errors }: ToastProps) {
	const dispatch = useAppDispatch();
	const nonConnectionErrors = errors.filter(
		(error) => error.type !== "connection",
	);
	const connectionErrors = uniqBy(
		errors.filter((error) => error.type === "connection"),
		"id",
	);

	useEffect(() => {
		errors.forEach((error) => {
			switch (error.type) {
				case "memoryRef":
					dispatch(
						updateMemoryRef({
							sheetIndex: error.sheet,
							memoryRefId: error.id,
							data: { error: true },
						}),
					);
					break;
				case "operator":
					dispatch(
						updateOperator({
							sheetIndex: error.sheet,
							operatorId: error.id,
							data: { error: true },
						}),
					);
					break;
				case "connection":
					dispatch(
						updateConnection({
							sheetIndex: error.sheet,
							connectionId: error.id,
							data: { error: true },
						}),
					);
					break;
			}
		});
	});

	const handleClick = (error: IoErrors) => {
		dispatch(selectTab(error.sheet));

		dispatch(
			moveSheetTo({
				index: error.sheet,
				position: error.box,
			}),
		);
	};

	return (
		<div>
			<strong>{title}</strong>
			<ul style={{ listStyle: "none" }}>
				{[...nonConnectionErrors, ...connectionErrors].map((error) => {
					return (
						<li
							key={`toast-message-${error.id}`}
							style={{ cursor: "pointer" }}
							onClick={(e) => {
								e.preventDefault();
								handleClick(error);
							}}
						>
							{error.message}
						</li>
					);
				})}
			</ul>
		</div>
	);
}
